module.exports = __webpack_public_path__ + "static/media/augmented-reality-hololens.9a300f0c.png";